const CLARITY_SCRIPT_ID = 'ms-clarity-script'

type ClarityFunction = (...args: unknown[]) => void

type ClarityWindow = Window & {
  clarity?: ClarityFunction & { q?: unknown[] }
}

export const initialiseClarity = (projectId: string): void => {
  const trimmedId = projectId.trim()
  if (!trimmedId) {
    return
  }

  if (typeof window === 'undefined' || typeof document === 'undefined') {
    return
  }

  const clarityWindow = window as ClarityWindow

  if (!clarityWindow.clarity) {
    clarityWindow.clarity = function (...args: unknown[]): void {
      ;(clarityWindow.clarity!.q = clarityWindow.clarity!.q || []).push(args)
    }
  }

  if (document.getElementById(CLARITY_SCRIPT_ID)) {
    return
  }

  const script = document.createElement('script')
  script.id = CLARITY_SCRIPT_ID
  script.type = 'text/javascript'
  script.async = true
  script.src = `https://www.clarity.ms/tag/${trimmedId}`
  const firstScript = document.getElementsByTagName('script')[0]
  firstScript?.parentNode?.insertBefore(script, firstScript)
}

export const setClarityTag = (key: string, value: string): void => {
  if (typeof window === 'undefined') {
    return
  }

  const clarityFn = (window as ClarityWindow).clarity
  if (typeof clarityFn !== 'function') {
    return
  }

  const trimmedKey = key.trim()
  const trimmedValue = value.trim()
  if (!trimmedKey || !trimmedValue) {
    return
  }

  clarityFn('set', trimmedKey, trimmedValue)
}
